import { Card } from '@/components/ui/card';
import { Typography } from '@/lib/typography';

export function DashboardCard({ title, value, icon, color = 'bg-brand-100', emptyMessage }) {
  const showEmptyMessage = value === 0 && emptyMessage;

  return (
    <Card className="p-6 hover:shadow-lg transition-shadow duration-200" data-testid={`dashboard-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-slate-600">{title}</p>
          <p className="mt-2 text-gray-900">{value}</p>
          {showEmptyMessage && (
            <p className="text-slate-400 mt-1">{emptyMessage}</p>
          )}
        </div>
        {icon && (
          <div className={`p-3 rounded-lg ${color}`}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
}
